<ng-template #modal let-addModal>
  <div class="modal-header">
    <h2 id="order-template-preferences-title" class="modal-title">
      {{ this.modalTitle() || modalHeader | translate }}
    </h2>
    <button type="button" class="close" [title]="'dialog.close.text' | translate" (click)="hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="orderTemplateForm" ishFormSubmit #form="ngForm" (ngSubmit)="submitOrderTemplateForm()" novalidate>
    <div class="modal-body">
      <formly-form [form]="orderTemplateForm" [fields]="fields" [model]="model" />
    </div>

    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="orderTemplateForm.invalid && form.submitted"
        data-testing-id="order-template-dialog-submit"
      >
        {{ primaryButton | translate }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="hide()">
        {{ 'account.cancel.button.label' | translate }}
      </button>
    </div>
  </form>
</ng-template>
